<template lang="html">
  <div :class="['input-with-error-v2', klass]">
    <div :class="['input-container', locked ? 'locked-input-container' : '']">
      <input
        :type="type"
        :name="name"
        :class="['form-input', error ? 'error-input' : '']"
        :placeholder="placeholder"
        :value="value"
        @change="(event) => $emit('update:value', event.target.value)"
        @input="(event) => $emit('input:value', event.target.value)"
        :disabled="locked"
      />
      <img
        :src="`${this.publicImagePath}/lock_icon.png`"
        v-if="locked"
      >
      <div v-if="leftLinkText" class="left-link small-text bold link active" @click="$emit('left-link-click')">
        {{leftLinkText}}
      </div>
    </div>
    <div class="error-message" v-if="error">{{error}}</div>

  </div>
</template>

<script>
export default {
  props: {
    klass: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: '',
    },
    locked: {
      type: Boolean,
      default: false,
    },
    leftLinkText: {
      type: String,
      default: undefined,
    }
  },
}
</script>

<style lang="scss" scoped>
.input-container {
  position: relative;

  .left-link {
    position: absolute;
    right: 0;
    bottom: -24px;
  }
}

.error-message {
  color: #D00000 !important;
  letter-spacing: 0.045px;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  margin-top: 6px;
}

input:disabled {
  cursor: not-allowed;
  background: white;
}

.locked-input-container {
  position: relative;;
  width: 240px;

  img {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 18px;
    right: 8px;
  }

  input {
    padding-right: 48px;
    text-overflow: ellipsis;
  }

  @media screen and (max-width: 768px) {
    width: auto;
  }
}

.vendor-form-locked-input .locked-input-container  {
  width: auto;

  img {
    top: 12px
  }
}
</style>
